<template>
    <div
        class="inline-flex rounded-full border border-theme-border bg-theme-card p-1"
        role="group"
        aria-label="Periodo de cobro"
    >
        <button
            v-for="period in periods"
            :key="period"
            type="button"
            class="rounded-full px-4 py-1.5 text-sm font-medium transition"
            :class="
                period === value
                    ? 'bg-theme-primary text-theme-inverse'
                    : 'text-theme-muted hover:bg-theme-hover'
            "
            :aria-pressed="period === value"
            @click="select(period)"
        >
            {{ labelFor(period) }}
        </button>
    </div>
</template>

<script>
import { PLAN_PERIOD_LABELS } from "@/common/lib/plan-periods";

export default {
    name: "PlanPeriodSelector",
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        // Periodo elegido: "monthly" | "quarterly" | "yearly".
        value: { type: String, default: "monthly" },
        // Periodos que se ofrecen, en el orden en que se muestran.
        periods: { type: Array, default: () => [] }
    },
    methods: {
        labelFor(period) {
            return PLAN_PERIOD_LABELS[period] || period;
        },
        select(period) {
            if (period !== this.value) this.$emit("input", period);
        }
    }
};
</script>
